/**
 * 참가자 현재 상태 정의 (WS 샘플) — 기존 샘플(sampleParticipants.js)의 상태 정의에 "기록 없음"을 추가
 * - 실데이터에는 디스트레스가 한 번도 산출되지 않은 참가자가 있어 별도 상태로 구분합니다.
 */

// 참가자 현재 상태 — 목록 우측 배지와 상세 상단 "현재 상태" 태그에 함께 사용
// 디스트레스 단계 기준: 안정 ≤0.16 / 주의 0.17~0.60(주의·경고) / 고위험 ≥0.61 (개인 상세 DISTRESS_LEVELS와 같은 경계)
export const RISK_STATUS = {
  crisis: {
    filter: "crisis_episode",
    badge: "🚨 위기",
    tag: "🚨 긴급 위기 · 즉시 확인 필요",
    badgeSx: { backgroundColor: "#B91C1C", color: "#FFFFFF" },
    tagSx: { backgroundColor: "#B91C1C", color: "#FFFFFF" },
  },
  episode: {
    filter: "crisis_episode",
    badge: "⚡ 에피소드",
    tag: "⚡ 급성 악화(에피소드) 관리 필요",
    badgeSx: { backgroundColor: "#FFF1F2", color: "#DC2626", border: "1.5px solid #EF4444" },
    tagSx: { backgroundColor: "#FFF1F2", color: "#DC2626", border: "1.5px solid #EF4444" },
  },
  high: {
    filter: "high",
    dot: "#EF4444",
    label: "고위험",
    tag: "🔴 고위험 상태 지속 · 집중 관찰 필요",
    tagSx: { backgroundColor: "#FEE2E2", color: "#B91C1C" },
  },
  caution: {
    filter: "caution",
    dot: "#FACC15",
    label: "주의",
    tag: "🟡 주의 단계 · 변화 관찰 필요",
    tagSx: { backgroundColor: "#FEF9C3", color: "#854D0E" },
  },
  stable: {
    filter: "stable",
    dot: "#22C55E",
    label: "안정",
    tag: "🟢 안정 유지 중",
    tagSx: { backgroundColor: "#DCFCE7", color: "#15803D" },
  },
  none: {
    filter: "none",
    dot: "#D1D5DB",
    label: "기록 없음",
    tag: "⚪ 디스트레스 기록 없음",
    tagSx: { backgroundColor: "#F3F4F6", color: "#6B7280" },
  },
};

// 좌측 [위험도] 드롭다운 옵션
export const RISK_FILTER_OPTIONS = [
  { value: "전체", label: "위험도 전체" },
  { value: "crisis_episode", label: "🚨 위기·에피소드" },
  { value: "high", label: "🔴 고위험" },
  { value: "caution", label: "🟡 주의" },
  { value: "stable", label: "🟢 안정" },
  { value: "none", label: "⚪ 기록 없음" },
];

// 종합현황 도넛 4단계 → 좌측 위험도 필터 (🟠 중등도/경고는 "주의" 옵션에 포함)
export const DISTRESS_TO_RISK_FILTER = { stable: "stable", caution: "caution", warning: "caution", high: "high" };
